import { RouteRecordRaw } from 'vue-router';

const CustomerOverview = () => import('@/modules/customers/pages/CustomersOverview.vue');

const CustomerDetails = () => import('@/modules/customers/components/customer-details/CustomerDetails.vue');

const CustomerDetailsPage = () => import('@/modules/customers/pages/CustomerDetailsPage.vue');
const CustomerGeneralDetailsPage = () => import('@/modules/customers/pages/customer-details/CustomerGeneralDetailsPage.vue');
const CustomerAddressesDetailsPage = () => import('@/modules/customers/pages/customer-details/CustomerAddressesDetailsPage.vue');
const CustomerContactsDetailsPage = () => import('@/modules/customers/pages/customer-details/CustomerContactsDetailsPage.vue');
const CustomerActivitiesDetailsPage = () => import('@/modules/customers/pages/customer-details/CustomerActivitiesDetailsPage.vue');
const CustomerDocumentsDetailsPage = () => import('@/core/components/templates/details-page/DocumentsDetailsPage.vue');

const CUSTOMERS_ROUTES: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'CustomersOverview',
      component: CustomerOverview,
      beforeEnter: (to, from, next) => {
         const { query } = to;
         if (!query.sort) return next({ ...to, query: { ...query, sort: '-poked', page: '1', per_page: '100' } });

         return next();
      },
      children: [
         {
            path: ':id',
            name: 'CustomerDetail',
            component: CustomerDetails,
            beforeEnter: (to, from, next) => {
               const { query } = to;
               if (!query.sort) return next({ ...to, query: { ...query, sort: '-poked', page: '1', per_page: '100' } });

               return next();
            },
         },
      ],
   },
   {
      path: 'details/:id',
      name: 'CustomerOverviewDetails',
      component: CustomerDetailsPage,
      redirect: { name: 'CustomerGeneralDetailsPage' },
      children: [
         {
            path: 'general',
            name: 'CustomerGeneralDetailsPage',
            component: CustomerGeneralDetailsPage,
            meta: {
               id: 1,
            },
         },
         {
            path: 'addresses',
            name: 'CustomerAddressesDetailsPage',
            component: CustomerAddressesDetailsPage,
            meta: {
               id: 2,
            },
         },
         {
            path: 'contacts',
            name: 'CustomerContactsDetailsPage',
            component: CustomerContactsDetailsPage,
            meta: {
               id: 3,
            },
         },
         {
            path: 'activities',
            name: 'CustomerActivitiesDetailsPage',
            component: CustomerActivitiesDetailsPage,
            meta: {
               id: 4,
            },
         },
         {
            path: 'documents',
            name: 'CustomerDocumentsDetailsPage',
            component: CustomerDocumentsDetailsPage,
            meta: {
               id: 5,
            },
         },
      ],
   },
];

export { CUSTOMERS_ROUTES };
